import type {Collection} from 'services/series/types';
import type {SearchSchemas} from 'api/search.dto.generated';
import {mapGetCollectionDto} from 'services/series';
import type {SearchResult, SearchResultDto} from '../types';
import {mapHighlight} from './mapHighlight';
import {mapSeriesDocumentToSeriesWithRelationsDto} from './mapSeriesDocumentToSeriesWithRelationsDto';

export const mapCollectionHits = (
  dto: SearchResultDto<SearchSchemas.SeriesDocument>,
): SearchResult<Collection> => {
  return {
    hits: dto?.hits.hits.map(h =>
      mapGetCollectionDto(mapSeriesDocumentToSeriesWithRelationsDto(h._source)),
    ),
    highlights: dto?.hits.hits.map(h => mapHighlight(h.highlight)).flat(1),
    total: dto.hits.total.value,
  };
};
